import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ConnectivityService } from '@app/core/services/connectivity.service';

@Component({
  selector: 'app-error-banner',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (connectivity.hasErrors$ | async) {
      <div class="error-banner" role="alert" data-testid="connectivity-banner">
        <div class="error-banner-content">
          <svg class="error-banner-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/>
          </svg>
          <div class="error-banner-text">
            <strong>{{ 'CONNECTIVITY.TITLE' | translate }}</strong>
            <span>{{ 'CONNECTIVITY.MESSAGE' | translate }}</span>
          </div>
        </div>
        <div class="error-banner-actions">
          <button type="button" class="error-banner-retry"
                  (click)="onRetry()" data-testid="connectivity-retry">
            {{ 'CONNECTIVITY.RETRY' | translate }}
          </button>
          <button type="button" class="error-banner-dismiss" aria-label="Dismiss"
                  (click)="onDismiss()" data-testid="connectivity-dismiss">×</button>
        </div>
      </div>
    }
  `,
  styles: [`
    .error-banner {
      position: sticky;
      top: 60px;  /* sous le navbar fixe (h-15 = 60px) */
      z-index: 35; /* navbar = 40, donc en dessous */
      background: #fef2f2;
      border-bottom: 1px solid #fca5a5;
      color: #991b1b;
      padding: 10px 16px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 12px;
      font-size: 14px;
      box-shadow: 0 1px 3px rgba(0,0,0,0.04);
    }
    .error-banner-content { display: flex; align-items: center; gap: 12px; flex: 1; }
    .error-banner-icon { width: 20px; height: 20px; flex-shrink: 0; }
    .error-banner-text { display: flex; flex-direction: column; gap: 2px; }
    .error-banner-text strong { font-weight: 600; }
    .error-banner-text span { font-size: 13px; opacity: 0.85; }
    .error-banner-actions { display: flex; align-items: center; gap: 8px; }
    .error-banner-retry {
      padding: 6px 14px; background: #991b1b; color: white; border: none;
      border-radius: 6px; font-size: 13px; font-weight: 600; cursor: pointer;
    }
    .error-banner-retry:hover { background: #7f1d1d; }
    .error-banner-dismiss {
      background: transparent; border: none; color: #991b1b;
      font-size: 20px; cursor: pointer; padding: 0 6px;
    }
  `],
})
export class ErrorBannerComponent {
  readonly connectivity = inject(ConnectivityService);

  onRetry(): void {
    window.location.reload();
  }

  onDismiss(): void {
    this.connectivity.dismiss();
  }
}
